'use strict';

const omit = require('lodash.omit');
const querystring = require('querystring');
const getSocialWindowPosition = require('../../../social/helpers/getSocialWindowPosition');

const TWITTER_URL = 'https://twitter.com/intent/tweet?';

const twitter = {
    _listenWindowClose(twitterWindow) {
        return new Promise(resolve => {
            const interval = setInterval(() => {
                try {
                    if (twitterWindow === null || twitterWindow.closed) {
                        clearInterval(interval);
                        resolve();
                    }
                } catch (e) {
                    resolve();
                }
            }, 500);
        });
    },

    /**
     * Builds the url for the twitter popup
     * @param {object} options
     * @param {string} [options.text]       - pre-filled tweet text
     * @param {string} [options.url]        - url following tweet text
     * @param {array}  [options.hashtags]   - twitter hashtags following tweet text
     * @param {string} [options.via]        - a handle for twitter to tag as 'via @handle'
     *
     * Example tweet:
     *  options = { text: "Beautiful Items on ", url: "1stdibs.com", hashtags: ["hashtag1", "hashtag2"], via: "1stdibs"}
     *      => Pre-filled tweet = "Beautiful Items on 1stdibs.com #hashtag1 #hashtag2 via @1stdibs"
     *
     * @see https://dev.twitter.com/web/tweet-button
     */
    buildUrl(options) {
        // Twitter API
        const queryOptions = omit(
            {
                text: options.text,
                url: options.url,
                hashtags: Array.isArray(options.hashtags)
                    ? options.hashtags.join(',')
                    : options.hashtags,
                via: options.via,
            },
            val => typeof val === 'undefined' || val === ''
        );

        return TWITTER_URL + querystring.stringify(queryOptions);
    },

    openWindow(options) {
        const width = 665;
        const height = 500;
        const windowOptions = {
            scrollbars: 'yes',
            resizable: 'no',
            toolbar: 'no',
            height: height,
            width: width,
            top: 0,
            left: 0,
        };

        Object.assign(windowOptions, getSocialWindowPosition(height, width));
        return this._listenWindowClose(
            window.open(
                this.buildUrl(options),
                'twitter',
                querystring.stringify(windowOptions, ',')
            )
        );
    },
};

module.exports = twitter;



// WEBPACK FOOTER //
// ./assets/js/global/utils/social/twitter.es.js